import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthenticationTokenStorageService } from '../session-storage/authentication.token.storage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationTokenStorageService: AuthenticationTokenStorageService
  ) { }

  /**
   * Chekif it is an Authenticated user
   *
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot | null
  ) {
    if (this.authenticationTokenStorageService.hasRootRole()) {
      return true;
    }

    const currentUser = this.authenticationTokenStorageService.getLoggedUser();
    const hasAnyRoles = route.data.hasAnyRoles;

    if (!hasAnyRoles && currentUser) {
      // Authenticated
      return true;
    }

    if (this.authenticationTokenStorageService.hasAnyRole(hasAnyRoles)) {
      // hasAnyRole
      return true;
    }

    if (currentUser) {
      // Authenticated not Autorized
      this.router.navigate(['private/unauthorized']);
      return false;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/'], { queryParams: { returnUrl: state?.url } });
    return false;
  }
}
